import { Link } from 'react-router-dom';
import { Icon, type MenuWrapperItem } from '@insio/ui-toolkit';

export const menuLinkClassName =
  'flex items-center gap-sm whitespace-nowrap px-md py-sm rounded-lg transition-colors hover:bg-background-muted';

/** One top-level menu entry rendered as a router Link, highlighted while its section is open. */
export function menuLink(
  label: string,
  icon: NonNullable<MenuWrapperItem['icon']>,
  href: string,
  isActive: boolean,
  extraProps?: Record<`data-${string}`, string>
): MenuWrapperItem {
  const tone = isActive ? 'text-secondary-base' : 'text-foreground-base';
  return {
    label,
    icon,
    href,
    isActive,
    item: (
      <Link to={href} className={menuLinkClassName} {...extraProps}>
        <Icon name={icon} className={tone} />
        <span className={`font-medium ${tone}`}>{label}</span>
      </Link>
    )
  };
}
